import React from 'react'
import SVGInline from "react-svg-inline"
import classnames from 'classnames';
import SidebarHeader from 'Components/sidebar-header';
import Panel from 'Components/panel';
import PanelBody from 'Components/panel/body';
import { __, sprintf } from 'StylistParent/i18n';
import Control from 'Components/control';
import CSSSelector from 'Components/css-selector';
import ResizeAndDragBox from 'react-rnd';

/* Import CSS */
import './index.scss'

class Sidebar extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			codeEditorMoved: false,
			previewAreaHeight: 0,
			initialSidebarPosX: 0,
			currentPanel: false,
			openPanel: true, // Used to hard-update/re-render controls.
		}

		// This binding is necessary to make `this` work in the callback
		this.handleHoverOn = this.handleHoverOn.bind( this )
		this.handleHoverOff = this.handleHoverOff.bind( this )
	}

	componentDidMount = () => {
		this.previewCoverEl = document.getElementById( "preview-cover" )
		this.previewAreaEl = document.getElementById( "stylist-preview-area" )
		const sidebarWidth = 280
		const panels = 88 // Top panels: 32px + 56px
		const previewAreaBottomPseudoPadding = 1000
		/**
		 * +1000 – is a hack needed to make floating sidebar movable to the bottom
		 * of the page when it has 100% of the heigh. 1000px is like a padding that
		 * expends draggable area.
		 */

		this.setState( {
			previewAreaHeight: this.previewAreaEl.offsetHeight - previewAreaBottomPseudoPadding - panels,
			initialSidebarPosX: this.previewAreaEl.offsetWidth - sidebarWidth,
		} )
	}

	componentDidUpdate = ( prevProps, prevState ) => {
		/**
		 * There is a very bad bug caused by <ResizeAndDragBox> component:
		 * it makes impossible to use any refs inside the componentDidMount().
		 * In our case we need to call CodeMirror by reference.
		 * To sole this problem we have to initiate CodeMirror editor
		 * outside the <Sidebar> component and then move it's code here
		 * once the user clicks on the "Code" tab inside sidebar.
		 */
		if ( this.props.sidebarTab === 'code' ) {
			/**
			 * this.state.codeEditorMoved prevents this code to run on every
			 * "Code" tab click, but only once in a life-time.
			 */
			if ( ! this.state.codeEditorMoved ) {
				// Move CodeMirror editor from the global dive into the "Code" tab.
				document.querySelector( '.stylist-sidebar--code' ).appendChild(
					document.querySelector( '.stylist-root .CodeMirror' )
				)

				this.setState( {
					codeEditorMoved: true
				} )
			}

			// On every Code tab click refresh editor view and focus on it.
			window.Stylist.codeEditor.refresh()
			window.Stylist.codeEditor.focus()
		}
	}

	handleHoverOn() {
		window.Stylist.iBody.classList.add( 'stlst-hide-highlight-box' )
	}

	handleHoverOff() {
		window.Stylist.iBody.classList.remove( 'stlst-hide-highlight-box' )
		// Redraw highlight box in case element dimensions changed.
		window.stlst_legacy.draw()
	}

	handleOnPanelToggle = ( currentPanelId ) => {
		if ( currentPanelId ) {
			this.setState( {
				currentPanel: currentPanelId,
			} )
		}
	}

	isPanelOpen = ( panelId ) => {
		if ( panelId === this.state.currentPanel ) {
			return true /* eslint-disable no-else-return */
		} else {
			return false
		}
	}

	onSidebarTabChange = ( newId ) => {
		this.props.onSidebarTabChange( newId )
	}

	updateSidebarDimensions = () => {

	}

	render() {
		// const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
		// const currentStyle = window.stylistJsData.currentlyEditingTitle;

		const fontWeightOptions = [
			{
				value: '100',
				label: __( 'Thin' ) + ' 100',
			},
			{
				value: '200',
				label: __( 'Extra-Light' ) + ' 200',
			},
			{
				value: '300',
				label: __( 'Light' ) + ' 300',
			},
			{
				value: '400',
				label: __( 'Regular' ) + ' 400',
				default: true,
			},
			{
				value: '500',
				label: __( 'Semi-Bold' ) + ' 500',
			},
			{
				value: '600',
				label: __( 'Bold' ) + ' 600',
			},
			{
				value: '700',
				label: __( 'Extra-Bold' ) + ' 700',
			},
			{
				value: '800',
				label: __( 'Black' ) + ' 800',
			},

		];

		const fontStyleOptions = [
			{
				icon: 'editor-textcolor',
				title: __( 'Normal' ),
				value: 'normal',
			},
			{
				icon: 'editor-italic',
				title: __( 'Italic' ),
				value: 'italic',
			},
		];

		const textAlignOptions = [
			{
				icon: 'editor-alignleft',
				title: __( 'Align left' ),
				value: 'left',
			},
			{
				icon: 'editor-aligncenter',
				title: __( 'Align center' ),
				value: 'center',
			},
			{
				icon: 'editor-alignright',
				title: __( 'Align right' ),
				value: 'right',
			},
		];

		const textTransformOptions = [
			{
				icon: 'editor-uppercase',
				title: __( 'Uppercase' ),
				value: 'uppercase',
			},
			{
				icon: 'editor-lowercase',
				title: __( 'Lowercase' ),
				value: 'lowercase',
			},
			{
				icon: 'editor-capitalize',
				title: __( 'Capitalize' ),
				value: 'capitalize',
			},
		];

		const wordWrapOptions = [
			{
				icon: 'editor-uppercase',
				title: __( 'Normal' ),
				value: 'normal',
			},
			{
				icon: 'editor-break',
				title: __( 'Break Word' ),
				value: 'break-word',
			},
		];

		const textDecorationOptions = [
			{
				icon: 'editor-underline',
				title: __( 'Underline' ),
				value: 'underline',
			},
			{
				icon: 'editor-overline',
				title: __( 'Overline' ),
				value: 'overline',
			},
			{
				icon: 'editor-strikethrough',
				title: __( 'Through' ),
				value: 'line-through',
			},
		];

		const borderStyleOptions = [
			{
				icon: 'border-solid',
				title: __( 'Solid' ),
				value: 'solid',
			},
			{
				icon: 'border-dotted',
				title: __( 'Dotted' ),
				value: 'dotted',
			},
			{
				icon: 'border-dashed',
				title: __( 'Dashed' ),
				value: 'dashed',
			},
			{
				icon: 'no-alt-2',
				title: __( 'Hidden' ),
				value: 'hidden',
			},
		];

		const simpleAdvancedControlOptions = [
			{
				icon: 'admin-customizer',
				title: __( 'Simple' ),
				value: 'simple',
			},
			{
				icon: 'admin-settings',
				title: __( 'Advanced' ),
				value: 'advanced',
			},
		];

		return (
			// this.props.showSidebar && // @todo: delete showSidebar completely
			<ResizeAndDragBox
				ref={ c => {
					this.rnd = c;
				} }
				className="stylist-sidebar-wrapper"
				dragHandleClassName=".components-panel__header"
				dragAxis="both"
				bounds="#stylist-preview-area"
				z="60000"
				minWidth={280}
				default={ {
					x: this.state.initialSidebarPosX,
					y: 0,
					width: 280, // width: "280px"
					height: this.state.previewAreaHeight,
				} }

				enableResizing={ {
					top: false,
					right: true,
					bottom: false,
					left: true,
					topRight: true,
					bottomRight: false,
					bottomLeft: true,
					topLeft: false
				} }

				onResizeStart={ () => {
					this.previewCoverEl.classList.add( 'active' )
				} }

				onResizeStop={ () => {
					this.previewCoverEl.classList.remove( 'active' )
				} }

				onDragStart={ ( e, ui ) => {
					this.previewCoverEl.classList.add( 'active' )
				} }

				onDragStop={ ( e, ui ) => {
					this.rnd.updateSize( {
						width: this.rnd.resizable.state.width,
						height: this.state.previewAreaHeight - ui.y
					} )
					this.previewCoverEl.classList.remove( 'active' )
				} }
			>
				<div
					id="stylist-sidebar"
					className="stylist-sidebar"
					onMouseEnter={this.handleHoverOn}
					onMouseLeave={this.handleHoverOff}
					ref={ el => this.el = el }
				>
					<SidebarHeader
						sidebarTab={this.props.sidebarTab}
						onSidebarTabChange={this.onSidebarTabChange} />
					{ this.props.sidebarTab === 'styling' &&
						! this.props.inspectorActive &&
						<div>
							<Panel header="Header Label">
								<div className="stylist-sidebar-content">
									<PanelBody
										className="editor-block-inspector__content"
										title={ __( 'Text' ) }
										initialOpen={ false }
										panelId={'text'}
										onToggle={ () => this.handleOnPanelToggle( 'text' ) }
										currentPanel={ this.state.currentPanel } >
										<Control
											type="slider"
											name={ __( 'Font Size' ) }
											cssProperty="font-size"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 100,
															min: 6,
														},
														em: {
															step: .01,
															max: 10,
															min: 0,
														},
														'%': {
															step: 1,
															max: 500,
															min: 10,
														},
													}
												}
											} />
										<Control
											type="slider"
											name={ __( 'Font Weight' ) }
											cssProperty="font-weight"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														'': {
															step: 100,
															max: 800,
															min: 100,
														},
													},
													// marks: {
													// 	100: 'Thin', // Thin
													// 	200: '',
													// 	300: '',
													// 	400: 'Regular', // Regular
													// 	500: '',
													// 	600: 'Bold', // Bold
													// 	700: '',
													// 	800: 'Black', // Black
													// },
													showInput: false,
												}
											} />
										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="color"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }>

											<Control
												type="font"
												name={__( 'Font Family' )}
												cssProperty="font-family"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={fontWeightOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={__( 'Text Align' )}
												cssProperty="text-align"
												cssDefault="start"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textAlignOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="slider"
												name={ __( 'Line Height' ) }
												cssProperty="line-height"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 200,
																min: 6,
															},
															em: {
																step: .01,
																max: 14,
																min: 0,
															},
															'': {
																step: .05,
																max: 14,
																min: 0,
															},
														}
													}
												} />

											<Control
												type="radio"
												name={ __( 'Font Style' ) }
												cssProperty="font-style"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={fontStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={__( 'Text Transform' )}
												cssProperty="text-transform"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textTransformOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="slider"
												name={ __( 'Letter Spacing' ) }
												cssProperty="letter-spacing"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: .25,
																max: 25,
																min: -25,
															},
															em: {
																step: .001,
																max: 2,
																min: -2,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Word Spacing' ) }
												cssProperty="word-spacing"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: .5,
																max: 25,
																min: -25,
															},
															em: {
																step: .001,
																max: 2,
																min: -2,
															}
														}
													}
												} />
											<Control
												type="slider"
												name={ __( 'Text Indent' ) }
												cssProperty="text-indent"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 100,
																min: -100,
															},
															em: {
																step: .001,
																max: 4,
																min: -4,
															},
															'%': {
																step: 1,
																max: 50,
																min: -50,
															},
														},
														marks: {
															px: {
																100: '100',
																50: '50',
																0: '0',
																'-50': '-50',
																'-100': '-100',
															},
															em: {
																0: '0',
															},
															'%': {
																0: '0',
															},
														},
													}
												} />
											<Control
												type="radio"
												name={ __( 'Text Decoration' ) }
												cssProperty="text-decoration"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={textDecorationOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="radio"
												name={ __( 'Word Wrap' ) }
												cssProperty="word-wrap"
												cssDefault="normal"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={wordWrapOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Background' )}
										initialOpen={false}
										panelId={'background'}
										onToggle={ () => this.handleOnPanelToggle( 'background' ) }
										currentPanel={ this.state.currentPanel }>

										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="background-color"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<Control
											type="upload"
											name={ __( 'Image' ) }
											cssProperty="background-image"
											cssDefault="none"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											// values={fontStyleOptions}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<Control
											type="radio"
											name={ __( 'Repeat' ) }
											cssProperty="background-repeat"
											cssDefault="repeat"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											values={[
												{
													icon: 'grid',
													title: __( 'Both Ways' ),
													value: 'repeat',
												},
												{
													icon: 'ellipsis',
													title: __( 'Horizontally' ),
													value: 'repeat-x',
												},
												{
													icon: 'ellipsis-vertical',
													title: __( 'Vertically' ),
													value: 'repeat-y',
												},
												{
													icon: 'no-alt-2',
													title: __( 'None' ),
													value: 'no-repeat',
												},
											]}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }>

											<Control
												type="radio"
												name={ __( 'Fixed' ) }
												cssProperty="background-attachment"
												cssDefault="scroll"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={[
													{
														icon: 'admin-post',
														title: __( 'Fixed' ),
														value: 'fixed',
													},
													{
														icon: 'no-alt-2',
														title: __( 'None' ),
														value: 'scroll',
													},
												]}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="radio"
												name={ __( 'Size' ) }
												cssProperty="background-size"
												cssDefault="auto"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={[
													{
														icon: 'editor-expand',
														title: __( 'Cover' ),
														value: 'cover',
													},
													{
														icon: 'editor-contract',
														title: __( 'Contain' ),
														value: 'contain',
													},
												]}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />

											<Control
												type="slider"
												name={ __( 'Horizontal Position' ) }
												cssProperty="background-position-x"
												cssDefault="0"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 1000,
																min: 0,
															},
															'%': {
																step: .05,
																max: 100,
																min: 0,
															},
															wh: {
																step: .05,
																max: 100,
																min: 0,
															},
															em: {
																step: .01,
																max: 70,
																min: 0,
															},
														},
														marks: {
															px: {},
															vw: {
																0: '0%',
																50: '50%',
																100: '100%'
															},
															em: {},
															'%': {
																0: 'Left',
																50: 'Center',
																100: 'Right'
															}
														}
													}
												} />

											<Control
												type="slider"
												name={ __( 'Vertical Position' ) }
												cssProperty="background-position-y"
												cssDefault="0"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 1000,
																min: 0,
															},
															'%': {
																step: .05,
																max: 100,
																min: 0,
															},
															vh: {
																step: .05,
																max: 100,
																min: 0,
															},
															em: {
																step: .01,
																max: 70,
																min: 0,
															},
														},
														marks: {
															px: {},
															vh: {
																0: '0%',
																50: '50%',
																100: '100%'
															},
															em: {},
															'%': {
																0: 'Top',
																50: 'Center',
																100: 'Bottom'
															}
														}
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Margin' )}
										initialOpen={false}
										panelId={'margin'}
										onToggle={ () => this.handleOnPanelToggle( 'margin' ) }
										currentPanel={ this.state.currentPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="margin"
											cssDefault="initial"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 200,
															min: 0,
														},
														em: {
															step: .01,
															max: 14,
															min: 0,
														},
														'%': {
															step: .05,
															max: 10,
															min: 0,
														},
													}
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }>
											<Control
												type="slider"
												name={ __( 'Top' ) }
												cssProperty="margin-top"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ -50, 200 ],
														rangePC: [ -100, 100 ],
														rangeEM: [ -6, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Right' ) }
												cssProperty="margin-right"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ -50, 200 ],
														rangePC: [ -100, 100 ],
														rangeEM: [ -6, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom' ) }
												cssProperty="margin-bottom"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ -50, 200 ],
														rangePC: [ -100, 100 ],
														rangeEM: [ -6, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Left' ) }
												cssProperty="margin-left"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ -50, 200 ],
														rangePC: [ -100, 100 ],
														rangeEM: [ -6, 26 ],
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Padding' )}
										initialOpen={false}
										panelId={'padding'}
										onToggle={ () => this.handleOnPanelToggle( 'padding' ) }
										currentPanel={ this.state.currentPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="padding"
											cssDefault="initial"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													decimals: 0,
													rangePX: [ 0, 200 ],
													rangePC: [ 0, 100 ],
													rangeEM: [ 0, 26 ],
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }>
											<Control
												type="slider"
												name={ __( 'Top' ) }
												cssProperty="padding-top"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Right' ) }
												cssProperty="padding-right"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom' ) }
												cssProperty="padding-bottom"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Left' ) }
												cssProperty="padding-left"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Rounded Corners' )}
										initialOpen={false}
										panelId={'border-radius'}
										onToggle={ () => this.handleOnPanelToggle( 'border-radius' ) }
										currentPanel={ this.state.currentPanel }>
										<Control
											type="slider"
											name={ __( 'All Sides' ) }
											cssProperty="border-radius"
											cssDefault="initial"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 100,
															min: 0,
														}
													}
												}
											} />
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={ __( 'Advanced' ) }
											initialOpen={ false }>
											<Control
												type="slider"
												name={ __( 'Top-Left' ) }
												cssProperty="border-top-left-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Top-Right' ) }
												cssProperty="border-top-right-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom-Right' ) }
												cssProperty="border-bottom-right-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
											<Control
												type="slider"
												name={ __( 'Bottom-Left' ) }
												cssProperty="border-bottom-left-radius"
												cssDefault="initial"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														decimals: 0,
														rangePX: [ 0, 200 ],
														rangePC: [ 0, 100 ],
														rangeEM: [ 0, 26 ],
													}
												} />
										</PanelBody>
									</PanelBody>
									<PanelBody
										className="editor-block-inspector__content"
										title={__( 'Border' )}
										initialOpen={false}
										panelId={'border'}
										onToggle={ () => this.handleOnPanelToggle( 'border' ) }
										currentPanel={ this.state.currentPanel }>

										<Control
											type="slider"
											name={ __( 'Width' ) }
											cssProperty="border-width"
											cssDefault="inherit"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl}
											advanced={
												{
													units: {
														px: {
															step: 1,
															max: 50,
															min: 0,
														},
														em: {
															step: .01,
															max: 5,
															min: 0,
														}
													}
												}
											} />
										<Control
											type="radio"
											name={ __( 'Style' ) }
											cssProperty="border-style"
											cssDefault="none"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											values={borderStyleOptions}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />
										<Control
											type="color"
											name={ __( 'Color' ) }
											cssProperty="border-color"
											cssDefault="transparent"
											notice=""
											onResponsiveModeToggle={this.props.onResponsiveModeToggle}
											currentPreviewWidth={this.props.currentPreviewWidth}
											cssSelectorFull={this.props.cssSelectorFull}
											cssSelectorCustom={this.props.cssSelectorCustom}
											cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
											selectedEl={this.props.selectedEl} />

										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Top' )}
											initialOpen={false}>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-top-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-top-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-top-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Right' )}
											initialOpen={false}>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-right-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-right-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-right-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Bottom' )}
											initialOpen={false}>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-bottom-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-bottom-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-bottom-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>
										<PanelBody
											className="editor-block-inspector__content stlst-inspector-advanced"
											title={__( 'Left' )}
											initialOpen={false}>

											<Control
												type="slider"
												name={ __( 'Width' ) }
												cssProperty="border-left-width"
												cssDefault="inherit"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl}
												advanced={
													{
														units: {
															px: {
																step: 1,
																max: 50,
																min: 0,
															},
															em: {
																step: .01,
																max: 5,
																min: 0,
															}
														}
													}
												} />
											<Control
												type="radio"
												name={ __( 'Style' ) }
												cssProperty="border-left-style"
												cssDefault="none"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												values={borderStyleOptions}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
											<Control
												type="color"
												name={ __( 'Color' ) }
												cssProperty="border-left-color"
												cssDefault="transparent"
												notice=""
												onResponsiveModeToggle={this.props.onResponsiveModeToggle}
												currentPreviewWidth={this.props.currentPreviewWidth}
												cssSelectorFull={this.props.cssSelectorFull}
												cssSelectorCustom={this.props.cssSelectorCustom}
												cssCurrentPseudoClass={this.props.cssCurrentPseudoClass}
												selectedEl={this.props.selectedEl} />
										</PanelBody>

									</PanelBody>
								</div>
							</Panel>
						</div>
					}
					{ this.props.sidebarTab !== 'code' && this.props.inspectorActive &&
						<div className="stylist-sidebar--active-inspector">
							{/* https://www.npmjs.com/package/react-svg-inline */}
							<SVGInline svg={ '<svg xmlns="http://www.w3.org/2000/svg" width="246" height="167" viewBox="0 0 246 167" version="1.1"><defs><linearGradient x1="0" y1="100" x2="93.3" y2="5.6" id="linearGradient-1"><stop stop-color="#9866FE" offset="0"/><stop stop-color="#009FD2" offset="71"/><stop stop-color="#02B9F3" offset="100"/></linearGradient><path d="M14.4 41.7L225.4 2.7C234.6 1 243.5 7.1 245.2 16.3 245.4 17.4 245.5 18.4 245.5 19.4L245.5 112.9C245.5 121.1 239.7 128.1 231.6 129.6L20.6 168.6C11.4 170.3 2.5 164.2 0.8 155 0.6 153.9 0.5 152.9 0.5 151.9L0.5 58.4C0.5 50.2 6.3 43.2 14.4 41.7Z" id="path-2"/><linearGradient x1="88.2" y1="56.6" x2="10.5" y2="80.6" id="linearGradient-4"><stop stop-color="#7A71F6" offset="0"/><stop stop-color="#00C2FF" offset="100"/></linearGradient><linearGradient x1="15.5" y1="77.3" x2="84" y2="-9" id="linearGradient-5"><stop stop-color="#AC11FE" offset="0"/><stop stop-color="#00C2FF" offset="100"/></linearGradient><rect id="path-6" x="0" y="0" width="38" height="74" rx="5"/></defs><g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="illustration" transform="translate(0.000000, -2.000000)"><g id="BG-shape"><mask id="mask-3" fill="white"><use xlink:href="#path-2"/></mask><use id="Mask" fill="url(#linearGradient-1)" xlink:href="#path-2"/><path d="M-43.3-24.2C-18.1-65.3 24.9-47.2 60.3-24.2 95.7-1.2 152.5 5.3 205.7-23.8 259-53 295.1 13.7 281.3 50.4 267.5 87.1 227.3 119.6 107.1 119.6 -13.2 119.6-68.5 16.9-43.3-24.2Z" id="Path-2" fill="url(#linearGradient-4)" opacity="0.2" mask="url(#mask-3)"/><path d="M274.8 139.4C256.2 200.9 181.4 174 148.9 159.4 116.4 144.7 115 181.1 58.1 200.9 1.2 220.7-72.9 194.7-42.9 159.4 -12.8 124 44.9 82.1 125.9 59.9 207 37.7 293.4 77.8 274.8 139.4Z" id="Path-2-Copy" fill="url(#linearGradient-5)" opacity="0.2" mask="url(#mask-3)"/></g><g id="MacBook" transform="translate(39.000000, 39.000000)"><rect id="Rectangle-2" fill="#24282D" x="15" y="0" width="146" height="100" rx="5"/><rect id="Rectangle-2-Copy-3" fill="#18B4FF" x="22" y="7" width="132" height="81" rx="1"/><g id="Group-2" transform="translate(0.000000, 93.000000)"><rect id="Rectangle-2-Copy" fill="#666B6F" x="0" y="0" width="176" height="7" rx="3"/><path d="M70 0L107 0C107 1.7 105.7 3 104 3L73 3C71.3 3 70 1.7 70 0Z" id="Combined-Shape" fill="#8A8F93"/></g><g id="Screen---desktop" transform="translate(35.000000, 17.000000)"><rect id="Browser" fill="#FFFFFF" x="0" y="0" width="108" height="71" rx="2"/><g id="Content---descktop" transform="translate(9.000000, 29.000000)"><g id="Illustration"><rect id="Rectangle-4-Copy" fill="#96D327" x="0" y="0" width="38" height="32" rx="2"/><path d="M38 7.7C34 10.6 28 12.5 20.2 13.3 12.2 14.2 5.5 16.5 0 20.1L0 2C0 0.9 0.9 0 2 0L36 0C37.1 0 38 0.9 38 2L38 7.7Z" id="Combined-Shape" fill="#A4EB21"/></g><g id="Text" transform="translate(47.000000, 0.000000)"><rect id="Rectangle-5-Copy-4" fill="#DADFE2" x="0" y="10" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-5" fill="#DADFE2" x="0" y="10" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-9" fill="#BFC9CE" x="0" y="0" width="32" height="5" rx="2.5"/><rect id="Rectangle-5-Copy-6" fill="#DADFE2" x="0" y="16" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-7" fill="#DADFE2" x="0" y="22" width="37" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-8" fill="#DADFE2" x="0" y="28" width="27" height="3" rx="1.5"/></g></g><g id="Header---descktop" transform="translate(1.000000, 7.000000)"><rect id="Rectangle-5" fill="#DADFE2" x="35" y="1" width="17" height="3" rx="1.5"/><path d="M0 12L107 12" id="Line" stroke="#DADFE2" opacity="0.4" stroke-linecap="square"/><rect id="Rectangle-5-Copy-3" fill="#0C93EB" x="9" y="0" width="10" height="6" rx="3"/><rect id="Rectangle-5-Copy" fill="#DADFE2" x="57" y="1" width="17" height="3" rx="1.5"/><rect id="Rectangle-5-Copy-2" fill="#DADFE2" x="79" y="1" width="17" height="3" rx="1.5"/></g></g></g><g id="iPhone" transform="translate(32.000000, 70.000000)"><g id="Rectangle-2-Copy-4"><use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-6"/><rect stroke="#24282D" stroke-width="2" x="1" y="1" width="36" height="72" rx="5"/></g><rect id="Rectangle-3" fill="#24282D" x="9" y="0" width="19" height="4" rx="2"/><g id="iPhone-Screen" transform="translate(3.000000, 9.000000)"><g id="Content---mobile" transform="translate(4.000000, 15.000000)"><g id="Illustration---mobile"><rect id="Rectangle-4-Copy-2" fill="#96D327" x="0" y="0" width="24" height="20" rx="2"/><path d="M24 5.2C21.5 7.1 17.7 8.4 12.8 8.9 7.7 9.5 3.5 10.9 0 13.3L0 2C0 0.9 0.9 0 2 0L22 0C23.1 0 24 0.9 24 2L24 5.2Z" id="Combined-Shape-Copy" fill="#A4EB21"/></g><g id="Text---mobile" transform="translate(0.000000, 25.000000)"><rect id="Rectangle-5-Copy-4" fill="#DADFE2" x="0" y="6.5" width="24" height="1.9" rx="1"/><rect id="Rectangle-5-Copy-9" fill="#BFC9CE" x="0" y="0" width="21" height="3.2" rx="1.6"/><rect id="Rectangle-5-Copy-7" fill="#DADFE2" x="0" y="10.3" width="24" height="1.9" rx="1"/><rect id="Rectangle-5-Copy-8" fill="#DADFE2" x="0" y="14.1" width="18" height="1.9" rx="1"/></g></g><g id="Header---mobile"><rect id="Rectangle-5-Copy-11" fill="#DADFE2" x="16" y="1" width="13" height="3" rx="1.5"/><path d="M0 10L32 10" id="Line-Copy" stroke="#DADFE2" opacity="0.4" stroke-linecap="square"/><rect id="Rectangle-5-Copy-10" fill="#0C93EB" x="3" y="0" width="9" height="5" rx="2.5"/></g></g></g><g id="Stars" transform="translate(15.000000, 3.000000)" fill="#FFFFFF" opacity="0.7"><path d="M62.4 16.2L62.4 16.2C61.4 16.6 60.3 16.1 59.9 15.2 59.8 14.7 59.8 14.2 59.9 13.7L59.9 13.7C61 11.1 61 8.1 59.9 5.4L59.9 5.4C59.6 4.4 60 3.3 61 2.9 61.5 2.8 62 2.8 62.4 2.9L62.4 2.9C65.1 4 68.1 4 70.7 2.9L70.7 2.9C71.7 2.6 72.8 3 73.2 4 73.4 4.5 73.4 5 73.2 5.4L73.2 5.4C72.1 8.1 72.1 11.1 73.2 13.7L73.2 13.7C73.6 14.7 73.1 15.8 72.2 16.2 71.7 16.4 71.2 16.4 70.7 16.2L70.7 16.2C68.1 15.1 65.1 15.1 62.4 16.2Z" id="Star" transform="translate(66.579533, 9.579533) rotate(45.000000) translate(-66.579533, -9.579533) "/><path d="M205.4 113.2L205.4 113.2C204.4 113.6 203.3 113.1 202.9 112.2 202.8 111.7 202.8 111.2 202.9 110.7L202.9 110.7C204 108.1 204 105.1 202.9 102.4L202.9 102.4C202.6 101.4 203 100.3 204 99.9 204.5 99.8 205 99.8 205.4 99.9L205.4 99.9C208.1 101 211.1 101 213.7 99.9L213.7 99.9C214.7 99.6 215.8 100 216.2 101 216.4 101.5 216.4 102 216.2 102.4L216.2 102.4C215.1 105.1 215.1 108.1 216.2 110.7L216.2 110.7C216.6 111.7 216.1 112.8 215.2 113.2 214.7 113.4 214.2 113.4 213.7 113.2L213.7 113.2C211.1 112.1 208.1 112.1 205.4 113.2Z" id="Star-Copy" transform="translate(209.579533, 106.579533) rotate(45.000000) translate(-209.579533, -106.579533) "/><path d="M3.8 42.4L3.8 42.4C3.1 42.7 2.4 42.4 2.1 41.7 1.9 41.4 1.9 41 2.1 40.7L2.1 40.7C2.8 38.8 2.8 36.7 2.1 34.8L2.1 34.8C1.8 34.1 2.1 33.4 2.8 33.1 3.1 32.9 3.5 32.9 3.8 33.1L3.8 33.1C5.7 33.8 7.8 33.8 9.7 33.1L9.7 33.1C10.4 32.8 11.2 33.1 11.4 33.8 11.6 34.1 11.6 34.5 11.4 34.8L11.4 34.8C10.7 36.7 10.7 38.8 11.4 40.7L11.4 40.7C11.7 41.4 11.4 42.2 10.7 42.4 10.4 42.6 10 42.6 9.7 42.4L9.7 42.4C7.8 41.7 5.7 41.7 3.8 42.4Z" id="Star-Copy-3" transform="translate(6.752870, 37.752870) rotate(45.000000) translate(-6.752870, -37.752870) "/><path d="M195.8 44.4L195.8 44.4C195.1 44.7 194.4 44.4 194.1 43.7 193.9 43.4 193.9 43 194.1 42.7L194.1 42.7C194.8 40.8 194.8 38.7 194.1 36.8L194.1 36.8C193.8 36.1 194.1 35.4 194.8 35.1 195.1 34.9 195.5 34.9 195.8 35.1L195.8 35.1C197.7 35.8 199.8 35.8 201.7 35.1L201.7 35.1C202.4 34.8 203.2 35.1 203.4 35.8 203.6 36.1 203.6 36.5 203.4 36.8L203.4 36.8C202.7 38.7 202.7 40.8 203.4 42.7L203.4 42.7C203.7 43.4 203.4 44.2 202.7 44.4 202.4 44.6 202 44.6 201.7 44.4L201.7 44.4C199.8 43.7 197.7 43.7 195.8 44.4Z" id="Star-Copy-2" transform="translate(198.752870, 39.752870) rotate(45.000000) translate(-198.752870, -39.752870) "/><path d="M167.4 151.5L167.4 151.5C166.9 151.7 166.3 151.4 166.1 150.9 166 150.6 166 150.3 166.1 150.1L166.1 150.1C166.7 148.6 166.7 146.9 166.1 145.4L166.1 145.4C165.8 144.9 166.1 144.3 166.6 144.1 166.9 144 167.2 144 167.4 144.1L167.4 144.1C168.9 144.7 170.6 144.7 172.1 144.1L172.1 144.1C172.6 143.8 173.2 144.1 173.5 144.6 173.6 144.9 173.6 145.2 173.5 145.4L173.5 145.4C172.8 146.9 172.8 148.6 173.5 150.1L173.5 150.1C173.7 150.6 173.4 151.2 172.9 151.5 172.6 151.6 172.3 151.6 172.1 151.5L172.1 151.5C170.6 150.8 168.9 150.8 167.4 151.5Z" id="Star-Copy-4" transform="translate(169.752870, 147.752870) rotate(45.000000) translate(-169.752870, -147.752870) "/></g></g></g></svg>' } />
							<h2>{ __( 'Easily style any page element' ) }</h2>
							{/* <ol>
								<li>{ __("Click on any page element") }</li>
								<li>{ __("Edit it's styling in this panel") }</li>
								<li>{ __("Check responsive presentation") }</li>
								<li>{ __("Save to apply changes") }</li>
							</ol> */}
						</div>
					}
					<div className={classnames( 'stylist-sidebar--code', { active: this.props.sidebarTab === 'code' } )}>
						{/* CodeMirror editor is being moved here on tab activation. */}
					</div>
				</div>
			</ResizeAndDragBox>
		)
	}
}

export default Sidebar;



// WEBPACK FOOTER //
// ./dev/stylist_parent/editor/sidebar/index.jsx